import React from 'react';
import styles from './ConditionBuilder.module.css';
import ConditionRow from '../ConditionRow/ConditionRow';
import Button from '../../common/Button/Button';

const EMPTY_CONDITION = {
  category: '',
  variable: '',
  variableTimeframe: '1m',
  operator: '',
  value: '',
  valueType: 'StaticValue',
  valueTimeframe: '1m',
  logicalOperator: 'AND',
};

const ConditionBuilder = ({ conditions = [], onChange, label = 'Conditions', config }) => {
  const handleConditionChange = (index, updated) => {
    const newConditions = [...conditions];
    newConditions[index] = updated;
    onChange(newConditions);
  };

  const handleRemove = (index) => {
    const newConditions = conditions.filter((_, i) => i !== index);
    onChange(newConditions);
  };

  const handleAdd = () => {
    onChange([...conditions, { ...EMPTY_CONDITION }]);
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h3 className={styles.label}>{label}</h3>
        <span className={styles.count}>{conditions.length} condition{conditions.length !== 1 ? 's' : ''}</span>
      </div>

      {conditions.length === 0 ? (
        <div className={styles.empty}>
          <span className="material-symbols-outlined" style={{ fontSize: 32, color: 'var(--text-muted)' }}>
            rule
          </span>
          <p>No conditions added yet.</p>
          <p className={styles.emptyHint}>Click "+ Add Condition" to start building your strategy logic.</p>
        </div>
      ) : (
        <div className={styles.list}>
          {conditions.map((condition, index) => (
            <ConditionRow
              key={index}
              condition={condition}
              index={index}
              onChange={handleConditionChange}
              onRemove={handleRemove}
              isLast={index === conditions.length - 1}
              config={config}
            />
          ))}
        </div>
      )}

      <div className={styles.addRow}>
        <Button variant="outline" onClick={handleAdd} icon="+" size="small">
          Add Condition
        </Button>
      </div>
    </div>
  );
};

export default ConditionBuilder;
